import React, { Component } from 'react';
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';

class PhotographerAvalableDates extends Component {
   render(){
       return(
           <div>
               <Calendar/>
           </div>
       )
   }

}

export default PhotographerAvalableDates